import "./logo.css.ts.vanilla.css-mistica.js";
var r = "_140ft6x0";
export { r as logoContainer };
